import { CourseType } from '../../../types'
import ROUTES from '../../utils/routes'
import { getCourseLessons } from './getCourseLessons'

// Returns where the user should be directed when
// clicking a course from the course library.

export const getCourseUrl = (course: CourseType, isOwned?: boolean) => {
  if (!isOwned || !course.modules) {
    return ROUTES.courses.previewBySlug(course.slug)
  }

  const allLessons = getCourseLessons(course)

  for (let i = 0; i < allLessons.length; i++) { 
    const lesson = allLessons[i]
    const { userLesson } = lesson
    const isLastLesson = i === allLessons.length - 1
    const isCompleted = userLesson?.isCompleted
    const isSkipped = userLesson?.isSkipped

    if (isLastLesson) {
      return ROUTES.courses.lessonBySlug(course.slug, lesson.slug)
    }

    if (!isCompleted && !isSkipped) {
      return ROUTES.courses.lessonBySlug(course.slug, lesson.slug)
    }
  }

  return ''
}
